import { CalendarPlusIcon } from './CalendarPlusIcon';

/**
 * author: Austin Andrews
 * id 34AFE807-D724-4A5A-A3FE-910928179BE8
 * name calendar-plus
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-plus.svg
 * tags
 * - Date / Time 
 */
export const EventPlusIcon = CalendarPlusIcon;
export default EventPlusIcon